import { LeftBar } from "../../components";
import Main from "./component.main";
import store from "./script.store";
const Users = { LeftBar, Main, store };
export default Users;
